import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from 'services/baseQueryWithAuth';

export interface GetNextPayoutAmountArgs {
  recipient_id: string;
}

export interface GetAdminRecipientsNextPayoutAmountResponse {
  next_payout_amount: number | null;
  next_payout_date: string;
}

export const nextPayoutAmountApi = createApi({
  reducerPath: 'nextPayoutAmountApi',
  tagTypes: ['NextPayout'],
  baseQuery: baseQueryWithAuth,
  endpoints: builder => ({
    getNextPayoutAmount: builder.query<
      GetAdminRecipientsNextPayoutAmountResponse,
      GetNextPayoutAmountArgs
    >({
      query: ({ recipient_id }) => ({
        url: `/admin/recipients/${recipient_id}/next-payout-amount`,
        method: 'GET',
      }),
      providesTags: (result, error, { recipient_id }) => [{ type: 'NextPayout', id: recipient_id }],
    }),
  }),
});

export const { useGetNextPayoutAmountQuery, useLazyGetNextPayoutAmountQuery } = nextPayoutAmountApi;
